Ext.define('SA.data.VendorDatasetSort', {
    constructor() {
        this.vendorSort = this.createVendorSort();
        this.datasetSort = this.createDatasetSort();
    },

    createDatasetSort() {
        var getPriorityIndex = value => ['PRZMPUS', 'PRZMUS'].indexOf(value.id),
            getSortValue = value => value.name.replace(/P\$YCLE/g, 'PSYCLE'),
            defaultCompare = (a, b) => getSortValue(a).localeCompare(getSortValue(b));

        return SA.data.Sort.getPrioritySorter({defaultCompare, getPriorityIndex});
    },

    createVendorSort() {
        var priorityList = ['EASI', 'AGS', 'Claritas', 'Simmons', 'SimplyAnalytics', 'U.S. Census Bureau', 'Bureau of Labor Statistics', 'FBI', 'NOAA'],
            getPriorityIndex = value => priorityList.indexOf(value.name),
            defaultCompare = (a, b) => a.name.localeCompare(b.name);

        return SA.data.Sort.getPrioritySorter({defaultCompare, getPriorityIndex});
    },

    getDatasetSort() {
        return this.datasetSort;
    },

    getVendorSort() {
        return this.vendorSort;
    }
});